import { useState, useCallback } from 'react';
import { NOTIFICATION_TYPE } from '../constants/status';

const useNotification = () => {
  const [notifications, setNotifications] = useState([]);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  }, []);

  const addNotification = useCallback(({ type = NOTIFICATION_TYPE.INFO, title, message, duration = 5000 }) => {
    const id = Date.now() + Math.random();
    const newNotification = { id, type, title, message, duration };
    
    setNotifications(prev => [...prev, newNotification]);
    
    // Автоматически удаляем уведомление после указанного времени
    if (duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, duration);
    }
    
    return id;
  }, [removeNotification]);

  const showSuccess = useCallback((message, title = 'Успешно') => {
    return addNotification({ type: NOTIFICATION_TYPE.SUCCESS, title, message });
  }, [addNotification]);

  const showError = useCallback((message, title = 'Ошибка') => {
    return addNotification({ type: NOTIFICATION_TYPE.ERROR, title, message });
  }, [addNotification]);

  const showWarning = useCallback((message, title = 'Предупреждение') => {
    return addNotification({ type: NOTIFICATION_TYPE.WARNING, title, message });
  }, [addNotification]);

  const showInfo = useCallback((message, title = 'Информация') => {
    return addNotification({ type: NOTIFICATION_TYPE.INFO, title, message });
  }, [addNotification]);

  const clearAll = useCallback(() => {
    setNotifications([]);
  }, []);

  return {
    notifications,
    addNotification,
    removeNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    clearAll
  };
};

export default useNotification; 